import { useAtabaseSettingsProductAdapter } from '@atabix/vue-ui'
import { computed } from 'vue'

import { useSettingsStore } from '@/stores/settings'

export function useAtabaseSettingsProduct() {
  const settingsStore = useSettingsStore()

  return useAtabaseSettingsProductAdapter({
    settings: computed(() => {
      const result = {
        products: settingsStore.settings['suite.products'],
        product: (settingsStore.settings['suite.product'] as string) === 'boilerplate' ? 'accounts' : settingsStore.settings['suite.product'],
      }

      if (result.products === undefined || result.product === undefined) {
        console.warn('[useAtabaseSettingsProduct] Settings needs to be realigned', result)
      }

      return result
    }),
  })
}
